<table>
    <thead>
        <tr>
            <th class="subtable string">{{'reetiquetado.table.tabs.confeccion.confeccion' | translate}}</th>
            <th class="subtable number">{{'reetiquetado.table.tabs.confeccion.etiquetas' | translate}}</th>
            <th class="subtable number">{{'reetiquetado.table.tabs.confeccion.kilos' | translate}}</th>
        </tr>
    </thead>
    <tbody *ngFor="let confeccion of confecciones; let i = index">
        <tr *ngIf="i < lastItemList && i >= firstItemList">
            <td class="string">{{confeccion.desConfeccion}}</td>
            <td class="number">{{confeccion.sumaNumEtiquetasReimpresas | number : '1.0-0': defaultLanguage}}</td>
            <td class="number">{{confeccion.sumaKgReimpresos | number : '1.2-2': defaultLanguage}}</td>
        </tr>
    </tbody>
    <tfoot>
        <tr>
            <td colspan="3">
                <app-paginator *ngIf="confecciones && confecciones.length > 0" [itemsPerPage]="itemsPerPage"
                    [currentPage]="currentPage" [totalItems]="totalItems" [visiblePages]="visiblePages" [hiddeItems]="true"
                    (pageChange)="pageChange($event)"></app-paginator>
            </td>
        </tr>
    </tfoot>
</table>
